import { Injectable, signal } from '@angular/core';

export interface ToastMessage {
  message: string
  type: 'success' | 'error' | 'info' | 'warning'
  id: number
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private toasts = signal<ToastMessage[]>([])
  private counter = 0

  readonly toastsSignal = this.toasts.asReadonly()

  show(message: string, type: ToastMessage['type'] = 'info', duration = 4000) {
    const id = this.counter++
    this.toasts.update(list => [...list, { message, type, id }])
    if (duration > 0) {
      setTimeout(() => this.dismiss(id), duration)
    }
  }

  dismiss(id: number) {
    this.toasts.update(list => list.filter(t => t.id !== id))
  }

  success(message: string) { this.show(message, 'success') }
  error(message: string) { this.show(message, 'error', 6000) }
  info(message: string) { this.show(message, 'info') }
  warning(message: string) { this.show(message, 'warning') }
}
